import getSelected from './getSelected';

// ----------------------------------------------------------------------------

function getValue(element: HTMLElement): any[] | undefined {
    return getSelected(element);
}

// ----------------------------------------------------------------------------

export default getValue;
